// removed by extract-text-webpack-plugin
module.exports = {"submit":"_1q63l","wrapper":"_2C4EA","form":"_2Pf8o","heading":"TEF9y","error":"_17Fd9"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Login.css
// module id = 859
// module chunks = 0